import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const RelatedArticles = ({ blogId }) => {
  const [related, setRelated] = useState([]);

  useEffect(() => {
    if (blogId) {
      axios.get(`${API}/blog/${blogId}/related`).then((res) => setRelated(res.data)).catch(() => {});
    }
  }, [blogId]);

  if (related.length === 0) return null;

  return (
    <div className="mt-16" data-testid="related-articles">
      <h3
        className="text-xl sm:text-2xl font-semibold mb-8"
        style={{ fontFamily: 'Outfit', color: '#0A0F1A' }}
      >
        Related Articles
      </h3>
      <div className="grid md:grid-cols-3 gap-6">
        {related.map((post) => (
          <Link
            key={post.id}
            to={`/blog/${post.id}`}
            data-testid={`related-${post.id}`}
            className="group block bg-white border border-[rgba(10,15,26,0.05)] overflow-hidden"
            style={{ textDecoration: 'none' }}
          >
            {post.image_url && (
              <img
                src={post.image_url}
                alt={post.title}
                className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-300"
              />
            )}
            {!post.image_url && (
              <div className="w-full h-40 flex items-center justify-center" style={{ backgroundColor: '#F1F5F9' }}>
                <span className="text-3xl" style={{ color: '#E2E8F0' }}>&#9781;</span>
              </div>
            )}
            <div className="p-5">
              <div className="flex items-center gap-3 mb-3">
                <span
                  className="text-xs uppercase tracking-[0.15em] font-semibold px-2 py-0.5"
                  style={{ backgroundColor: '#FFF4E6', color: '#FF5722' }}
                >
                  {post.category}
                </span>
                <span className="flex items-center gap-1 text-xs" style={{ color: '#94A3B8' }}>
                  <Clock size={12} /> {post.read_time}
                </span>
              </div>
              <h4
                className="text-base font-semibold mb-2 line-clamp-2 group-hover:text-[#FF5722] transition-colors"
                style={{ fontFamily: 'Outfit', color: '#0A0F1A', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}
              >
                {post.title}
              </h4>
              <span className="inline-flex items-center gap-1 text-xs font-medium" style={{ color: '#FF5722' }}>
                Read More <ArrowRight size={12} />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedArticles;
